import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default function JourneyStep({
  icon,
  value,
  label,
  conversion,
  bg = "bg-secondary",
}) {
  return (
    <>
      {conversion !== null && conversion !== undefined && (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="text-secondary ">{conversion}%</div>
          <FontAwesomeIcon className="text-secondary" icon={faArrowRight} />
        </div>
      )}

      <div className="text-center">
        <div
          className={`rounded-circle text-white d-inline-flex align-items-center justify-content-center mb-2 ${bg}`}
          style={{ width: 50, height: 50 }}
        >
          {icon}
        </div>
        <div className="h5 mb-0">{value}</div>
        <div className="small text-muted">{label}</div>
      </div>
    </>
  );
}
